/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export default {
  command_intelligence_drawer_title: 'Command Intelligence',
  command_intelligence_drawer_resize_handle: 'Vilkite, kad pakeistumėte skydelio dydį',
  command_intelligence_close_aria: 'Uždaryti asistentą',
  command_intelligence_send_aria: 'Siųsti žinutę',
  command_intelligence_stop_aria: 'Sustabdyti atsakymą',
  command_intelligence_composer_input_aria: 'Žinutė Command Intelligence',
  command_intelligence_drawer_more_options: 'Daugiau parinkčių',
  command_intelligence_dock_position: 'Tvirtinimo vieta',
  command_intelligence_dock_left: 'Kairė',
  command_intelligence_dock_right: 'Dešinė',
  command_intelligence_dock_top: 'Viršus',
  command_intelligence_dock_bottom: 'Apačia',
  command_intelligence_panel_layout: 'Skydelio išdėstymas',
  command_intelligence_panel_layout_overlap: 'Persidengti su turiniu',
  command_intelligence_panel_layout_push: 'Stumti turinį',
  command_intelligence_panel_auto_hide_overlap: 'Automatiškai slėpti paspaudus išorėje',
  command_intelligence_session_reset: 'Atstatyti pokalbį',
  command_intelligence_try_one_of_these: 'Išbandykite vieną iš šių',
  command_intelligence_attach_hint: 'Pridėkite konteksto elementus, kad galėtumėte užduoti klausimus.',
  command_intelligence_welcome_subhead: 'Užduokite klausimą, norėdami pradėti.',
  command_intelligence_attach_modal_title: 'Pridėti kontekstą',
  command_intelligence_attach_modal_subtitle:
    'Pasirinkite iš šio rodinio elementų. Jau pridėti elementai yra pilkinti.',
  command_intelligence_attach_modal_search_placeholder: 'Ieškoti…',
  command_intelligence_attach_modal_pool:
    '{count, plural, one {# elementas prieinamas} few {# elementai prieinami} other {# elementų prieinama}} · pasirinkta {selected}',
  command_intelligence_attach_modal_empty: 'Nėra ką pridėti',
  command_intelligence_attach_modal_no_results: 'Nė vienas elementas neatitinka paieškos',
  command_intelligence_context_bar_attached_section: 'Pridėta ({count})',
  command_intelligence_context_bar_clear_attached: 'Išvalyti',
  command_intelligence_context_bar_add: 'Pridėti kontekstą',
  command_intelligence_placeholder_ready: 'Užduokite klausimą…',
  command_intelligence_placeholder_attach: 'Pridėkite kontekstą, kad užduotumėte klausimą…',
  command_intelligence_composer_submit_hint: 'Enter siųsti · Shift+Enter naujai eilutei',
  command_intelligence_composer_stop_hint: 'Sustabdyti · juodraštis kitai žinutei laukiant',
  command_intelligence_response_stopped: 'Atsakymas sustabdytas',
  command_intelligence_generation_in_progress: 'Apdorojamas jūsų klausimas',
  command_intelligence_generation_trace_title: 'Atlikti žingsniai',
  command_intelligence_generation_trace_toggle: 'Rodyti žingsnius',
  command_intelligence_generation_trace_summary: 'Atlikta {completed} iš {total} žingsnių',
  command_intelligence_generation_trace_summary_generic: 'Generavimo žingsniai',
  command_intelligence_generation_tool_count: '{count, plural, one {# įrankis} few {# įrankiai} other {# įrankių}}',
  command_intelligence_generation_turn_label: 'Eiga {turn} iš {total}',
  command_intelligence_generation_turn_completed: 'Eiga {turn} iš {total} baigta',
  command_intelligence_generation_turn_completed_elapsed: 'Eiga {turn} iš {total} baigta (praėjo {seconds}s)',
  command_intelligence_generation_turn_completed_with_tools: 'Eiga {turn} iš {total} baigta – naudota {tools}',
  command_intelligence_generation_tools_used: 'Naudota {tools}',
  command_intelligence_reasoning_thinking: 'Galvoju…',
  command_intelligence_reasoning_thought_for_seconds: 'Galvojo {seconds} sekundes',
  command_intelligence_reasoning_waiting: 'Apdorojamas jūsų klausimas…',
  command_intelligence_attach_modal_done: 'Atlikta',
  command_intelligence_attach_modal_attached_badge: 'pridėta',
  command_intelligence_attach_modal_attach: 'Pridėti',
  command_intelligence_attach_modal_attach_count: 'Pridėti ({count})',
  command_intelligence_attach_modal_close_aria: 'Uždaryti parinkiklį',
  command_intelligence_session_limit_context: 'Pasiektas konteksto limitas. Atstatykite pokalbį, kad tęstumėte.',
  command_intelligence_session_limit_prompt: 'Pasiektas žinučių limitas. Atstatykite pokalbį, kad tęstumėte.',
  command_intelligence_suggested_followups: 'Siūlomi tolesni klausimai',
  command_intelligence_credit_warning_line: '{pct}% {scope} mėnesinių DI kreditų panaudota',
  command_intelligence_tooltip_prompts: '{count} iš {max} žinučių ({pct}%)',
  command_intelligence_tooltip_context: '{used} iš {max} konteksto žetonų ({pct}%)',
  command_intelligence_tooltip_context_idle: 'Konteksto naudojimas rodomas po pirmojo atsakymo',
  command_intelligence_credits_loading: 'Įkeliami kreditai…',
  command_intelligence_credits_unavailable: 'Kreditai nepasiekiami',
  command_intelligence_credits_tooltip: 'Mėnesiniai DI kreditai už {monthKey}',
  command_intelligence_credits_tooltip_short: 'Mėnesiniai DI kreditai',
  command_intelligence_credits_scope_profile: 'Profilis',
  command_intelligence_credits_scope_entity: 'Subjektas',
  command_intelligence_credits_used_of_cap: '{used} iš {cap} kreditų',
  command_intelligence_credits_used_no_cap: 'Panaudota {used} kreditų',
  command_intelligence_credits_monthly_title: 'Mėnesiniai DI kreditai',
  command_intelligence_compare_aria: 'Palyginti agentus',
  command_intelligence_compare_tooltip: 'Paleisti tą patį klausimą keliems agentų profiliams',
  command_intelligence_compare_cancelled: 'Palyginimas atšauktas',
  command_intelligence_compare_branch_failed: 'Palyginimo šaka nepavyko',
  command_intelligence_compare_title: 'Agentų palyginimas',
  command_intelligence_compare_stats: '{durationMs} ms · {model} · {inTok} įėj. / {outTok} išėj. · {agentRef}',
  command_intelligence_compare_error: '{message}',
  command_intelligence_profile_agent: '{agentRef}',
  command_intelligence_feedback_good_response: 'Geras atsakymas',
  command_intelligence_feedback_bad_response: 'Blogas atsakymas',
  command_intelligence_feedback_dialog_title: 'Pateikti atsiliepimą',
  command_intelligence_feedback_dialog_body:
    'Padėkite mums tobulėti pateikdami atsiliepimą apie šį atsakymą. Jūsų atsiliepimas bus išsiųstas mūsų operacijų komandai.',
  command_intelligence_feedback_response_label: 'Atsakymas',
  command_intelligence_feedback_input_label: 'Jūsų atsiliepimas (neprivaloma)',
  command_intelligence_feedback_input_placeholder: 'Kas šiame atsakyme buvo neteisinga ar nepadeda?',
  command_intelligence_feedback_submit: 'Pateikti atsiliepimą',
  command_intelligence_feedback_submit_error: 'Nepavyko pateikti atsiliepimo. Bandykite dar kartą.',
  command_intelligence_feedback_question_understanding: 'Ar agentas suprato, ko norėjote?',
  command_intelligence_feedback_question_readability: 'Ar atsakymas buvo lengvai skaitomas ir naudojamas?',
  command_intelligence_feedback_section_understanding: 'Supratimas',
  command_intelligence_feedback_section_readability: 'Skaitomumas',
  command_intelligence_feedback_choice_none: 'Nėra',
  command_intelligence_feedback_choice_misunderstood_task: 'Neteisingai suprato užduotį',
  command_intelligence_feedback_choice_ignored_constraint: 'Ignoravo apribojimą',
  command_intelligence_feedback_choice_wrong_scope: 'Neteisinga apimtis',
  command_intelligence_feedback_choice_visually_hard_to_read: 'Vizualiai sunku skaityti',
  command_intelligence_feedback_choice_wrote_too_much: 'Per daug parašė',
  command_intelligence_feedback_choice_explanation_not_trustworthy: 'Paaiškinimas nepatikimas',
  command_intelligence_copy_aria: 'Kopijuoti į iškarpinę',
  command_intelligence_error_missing_invoke_permission:
    'Neturite leidimo naudoti Command Intelligence šiam agentui. Paprašykite administratoriaus suteikti reikiamus Intelligence leidimus (pvz., analyst).',
  command_intelligence_access_denied_title: 'Reikalinga prieiga',
  command_intelligence_error_session_expired: 'Jūsų sesija baigėsi. Atnaujinkite puslapį ir prisijunkite iš naujo.',
};
